[
  {
    "title": "60 SECONDS IN...",
    "duration": "7 videos",
    "image": "/assets-optimized/redesign/insights/playlist/1.png",
    "link": "https://www.youtube.com/playlist?list=PLu_CKZK3SEq-WcMfg-TICZ29ZQ1peTq3N"
  },
  {
    "title": "MEET OUR BRANDS",
    "duration": "13 videos",
    "image": "/assets-optimized/redesign/insights/playlist/2.png",
    "link": "https://www.youtube.com/playlist?list=PLu_CKZK3SEq-WcMfg-TICZ29ZQ1peTq3N"
  },
  {
    "title": "THE POWER OF TRAVEL",
    "duration": "13 videos",
    "image": "/assets-optimized/redesign/insights/playlist/3.png",
    "link": "https://www.youtube.com/playlist?list=PLu_CKZK3SEq8LB39Q3VGuH6GyXauWuP8m"
  },
  {
    "title": "STORYBOOKED FILMS",
    "duration": "11 videos",
    "image": "/assets-optimized/redesign/insights/playlist/4.png",
    "link": "https://www.youtube.com/playlist?list=PLu_CKZK3SEq9yvqCixhxAkndhxsf52pEX"
  },
  {
    "title": "ABOUT THE JOURNEY",
    "duration": "12 videos",
    "image": "/assets-optimized/redesign/insights/playlist/5.png",
    "link": "https://www.youtube.com/playlist?list=PLu_CKZK3SEq833rGaLvhyqdwQCaSr9pii"
  },
  {
    "title": "MARRIOTT BONVOY OUTDOORS",
    "duration": "3 videos",
    "image": "/assets-optimized/redesign/insights/playlist/6.png",
    "link": "https://www.youtube.com/playlist?list=PLu_CKZK3SEq-HpHcAYsdMRk2U5VqZOthA"
  }
]